import { Record } from 'immutable'
import moment from 'moment'
import { ReminderPeriod, ReminderStatus } from './enums'

export interface IReminder {
  readonly id: string
  readonly number: number
  readonly period: ReminderPeriod
  readonly status: ReminderStatus
  readonly dateSent: moment.Moment
}

const ReminderRecord = Record({
  dateSent: moment(),
  id: '',
  number: 0,
  period: ReminderPeriod.Days,
  status: ReminderStatus.Unsent,
})

export class Reminder extends ReminderRecord implements IReminder {
  public static fromJS(initialState?: Partial<IReminder>) {
    if (!initialState) {
      return new Reminder()
    }

    const { ...rest } = initialState

    return new Reminder({
      ...rest,
    })
  }

  public readonly id: string
  public readonly number: number
  public readonly period: ReminderPeriod
  public readonly status: ReminderStatus
  public readonly dateSent: moment.Moment

  constructor(initialState?: Partial<Reminder>) {
    initialState ? super(initialState) : super()
  }
}
